import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ExportTransactionsReqData } from "./ExportTransactionsReqData";

const ENDPOINT = "/cash_flow/transaction_report/download";

export class DownloadCashReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: ExportTransactionsReqData = null;

    constructor(exportType: string, payload: ExportTransactionsReqData) {
        super();
        this.payload = payload;
        this.responseType = "blob";
        this.endPoint = this.endPoint + "/" + exportType;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.payload);
    }
}
